import classNames from 'classnames';
import React__default from 'react';
import Icon from '../../DataDisplay/Icon/Icon.js';
import '../../../styles/general.css.js';
import '../../../styles/fonts.css.js';
import '../../Forms/Checkbox/Checkbox.js';
import '../../DataDisplay/Table/Table.module.scss.js';
import '../../../styles/forms.css.js';
import '../Tooltip/Tooltip.js';
import '../../Forms/ButtonIcon/ButtonIcon.module.css.js';
import '../../DataDisplay/TextTruncate/TextTruncate.module.css.js';
import '../../Forms/Button/Button.module.scss.js';
import styles from './Footer.module.scss.js';

const Footer = ({ template = 'web', language = 'English', area = 'ED&AA', lastUpdate = '', published = '', background = 'light', showCopyright = true, showRestricted = false, appName, appVersion, infoLink, links, }) => {
    if (template === 'tableau') {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { style: {
                    fontFamily: 'Siemens',
                    fontSize: 13,
                    color: '#7b919d',
                    display: 'grid',
                    gridTemplateColumns: '2fr 2fr 2fr 2fr 1fr',
                    width: '100%',
                } },
                React__default.createElement("div", null,
                    "Siemens Energy",
                    React__default.createElement("br", null),
                    showRestricted ? 'Restricted ' : null,
                    "\u00A9 Siemens Energy",
                    ' ',
                    new Date().getFullYear(),
                    " All rights reserved"),
                React__default.createElement("div", { className: "text-center" }, area),
                React__default.createElement("div", { className: "text-center" },
                    published ? (React__default.createElement(React__default.Fragment, null,
                        "Published: ",
                        published,
                        " ",
                        React__default.createElement("br", null))) : null,
                    "Language: ",
                    language),
                React__default.createElement("div", { className: "text-center" }, lastUpdate ? (React__default.createElement(React__default.Fragment, null,
                    "Data as of: ",
                    React__default.createElement("br", null),
                    " ",
                    lastUpdate)) : null),
                React__default.createElement("div", { style: { textAlign: 'right' } },
                    React__default.createElement("div", { style: { display: 'inline-block' } }, infoLink ? (React__default.createElement("a", { href: infoLink, target: "_blank", rel: "noreferrer" },
                        React__default.createElement(Icon, { icon: "IconInformation", color: "#7b919d" }))) : null)))));
    }
    else {
        return (React__default.createElement("div", { style: { fontFamily: 'Siemens' }, className: classNames(styles.reactLib__Footer, styles[`${background}`]) },
            showCopyright ? (React__default.createElement("span", null,
                showRestricted ? 'Restricted ' : null,
                "\u00A9 Siemens Energy")) : null,
            appName || appVersion ? (React__default.createElement("div", { className: styles.reactLib__Footer__appNameVersion, style: { float: 'right' } },
                appName,
                " ",
                appVersion)) : null,
            React__default.createElement("div", { className: styles.reactLib__Footer__linksContainer, style: { float: 'right' } }, links
                ? links.map((link, index) => {
                    return (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("a", { key: index, href: link.url, target: link.target }, link.title),
                        index < links.length - 1 ? (React__default.createElement("div", { style: {
                                marginLeft: 10,
                                marginRight: 10,
                                display: 'inline-block',
                            } }, "|")) : appName || appVersion ? (React__default.createElement("div", { style: {
                                marginLeft: 10,
                                marginRight: 10,
                                display: 'inline-block',
                            } }, "|")) : null));
                })
                : null)));
    }
};

export { Footer as default };
//# sourceMappingURL=Footer.js.map
